const content  = {
    EN: {
      ID: 'Item No.',
      ColorCode: 'Color Code',
      Color: 'Description',
      GrossReq: 'Gross Requirement',
      ScheduledRcpt: 'Sched. Receipt',
      ExpectedDate: 'Exp. Date',
      Inventory: 'Inventory',
      ProjAvailBalance: 'Proj. Availability',
      message: 'Click on Expected Date to display detailed quantity and scheduled receipt dates',
      Variant: 'Variant Code',
      Expected: 'Expected Receipt Date',
      Quantity: 'Quantity'
    },
    GR: {
        ID: 'Κωδικός',
        ColorCode: 'Χρώμα',
        Color: 'Περιγραφή',
        GrossReq: 'Μικτές Ανάγκες',
        ScheduledRcpt: 'Προγρ. Παραλαβές',
        ExpectedDate: 'Αναμένεται',
        Inventory: 'Απόθεμα',
        ProjAvailBalance: 'Προγρ. Υπόλοιπο',
        message: 'Πατήστε στην Αναμενόμενη Ημερομηνία για να δείτε αναλυτικά τις προγραμματισμένες παραλαβές',
        Variant: 'Κωδ. Χρώματος',
      Expected: 'Αναμένεται',
      Quantity: 'Ποσότητα'
    },
  };

  export default content;


// WEBPACK FOOTER //
// ./src/components/itemdetailslist/content.js